import keyMirror from 'keymirror';

export const parentShopTypes = keyMirror({
	GET_LEVELS_REQUEST: null,
	GET_LEVELS_SUCCESS: null,
	GET_LEVELS_ERROR: null,

	GET_PACKAGES_REQUEST: null,
	GET_PACKAGES_SUCCESS: null,
	GET_PACKAGES_ERROR: null,

	HANDLE_USER_EXPERIMENT: null,
	HANDLE_USER_EXPERIMENT_SUCCESS: null,
	CLEAN_PACKAGES: null,
});
